module.exports = __webpack_public_path__ + "media/images/icons/store-275a3090a78e3c6605de7f7df09c4a87.svg";